export default __webpack_public_path__ + "static/media/LoudOne.c2318c16.jpg";